/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export { default as FileUploader } from './file-uploader';

// Styled elements
export { StyledFileRow, StyledFileRowColumn, StyledFileRowContent, StyledFileRowFileName, StyledFileRowText, StyledFileRowUploadMessage, StyledFileRowUploadText, StyledFileRows, StyledHint, StyledImagePreviewThumbnail, StyledItemPreviewContainer, StyledLabel, StyledParentRoot } from './styled-components';

// Flow
export * from './types';
export type { FileUploaderLocale } from './locale';